// Shared HTTP primitives. Lives separately from the generated client and the
// (being-retired) hand-written client so the Orval mutator can depend on it
// without a cycle.

export class ApiError extends Error {
  status: number
  body: unknown

  constructor(status: number, body: unknown) {
    const message = (body as { message?: string })?.message || `API error ${status}`
    super(message)
    this.status = status
    this.body = body
  }
}

// Event target for 401 handling — LoginModal listens for this
export const authEvents = new EventTarget()
